/**
 * analytics.ts — thin GA4 event wrapper.
 *
 * gtag is loaded in index.html (G-7NQE65D9W3) with Consent Mode v2:
 * analytics_storage defaults to 'denied' and the cookie banner flips it.
 * Events fired without consent are handled by Consent Mode (cookieless
 * pings / dropped), so calling this unconditionally is privacy-safe — do
 * NOT add consent checks here, that's Consent Mode's job.
 *
 * Conversion events in use (mark these as conversions in GA4 → Admin →
 * Events):
 *   - generate_lead      → contact form, ROI PDF gate, report download
 *   - roi_calculated     → ROI calculator "Calculate" (engagement signal)
 *   - newsletter_signup  → Field Notes signups
 */

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

export const trackEvent = (
  name: string,
  params?: Record<string, string | number | boolean>,
): void => {
  try {
    window.gtag?.('event', name, params);
  } catch {
    /* analytics must never break the UX */
  }
};
